import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {RxComponent} from 'app/core/components/common/rx.component';
import {ConfigService} from 'app/core/services/config.service';
import {Subject} from 'rxjs/Rx';
import {NotificationService} from 'app/core/services/notification.service';
import {ModalSize, SmartModalService} from 'app/core/services/smart-modal.service';
import {CertificatesService} from '../certificates.service';
import {CertificateCreateModalComponent} from './certificate-create-modal/certificate-create-modal.component';

@Component({
    selector: 'itpx-certificates',
    templateUrl: './certificates.component.html',
    styleUrls: ['./certificates.component.css']
})
export class CertificatesComponent extends RxComponent implements OnInit, OnDestroy {
    private bulkActionsConfig: any;
    private clearSelection = new Subject<any>();
    public url: string;
    public fields: any[];
    public gridRefresh = new Subject<any>();
    public guidelineLink: string = 'https://my.leapest.com/support?articleId=certificate-templates';

    constructor(private configService: ConfigService,
                private notificationService: NotificationService,
                private service: CertificatesService,
                private modalService: SmartModalService,
                private router: Router) {
        super();
        this.url = configService.get('server').url + configService.get('endpoints').organization.certificates.list.api;

        this.fields = this.service.getCertificateAvailableFields();
        this.bulkActionsConfig = {
            key: 'id',
            actions: [
                { name: 'delete', label: 'Delete', icon: 'fa-times'}
            ],
            clearSelection : this.clearSelection
        };
    }

    ngOnInit() {
    }

    onCreateNewClick() {
        this.modalService.open(CertificateCreateModalComponent,
            { },
            'Create New Certificate Template',
            ModalSize.Md)
            .neverError()
            .switchMap(res => {
                return this.service.createCertificate(res.result.createCertificate)
            })
            .bindToLifecycle(this)
            .subscribe(res => {
                console.log(res);
                setTimeout(() => {
                    this.gridRefresh.next(true);
                }, 50);
            })
    }

    ngOnDestroy() {
        this.modalService.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/certificates/components/certificates.component.ts